export default {
  BANNERS: "Banners",
  BANNER: "Banner",
};
